export function RegularScheduleVariationsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/regular-schedule-variations.svg'"></ng-include>`
    }
}